import { useEffect, useState } from "react";

const images = [
  "/assets/images/businesswoman-pointing-chart-with-pen.jpg",
  "/assets/images/happy-asian-parent-sitting-together-with-boy-floor-living-room-father-working-laptop-son-using-tablet-with-mother-looking-camera.jpg",
  "/assets/images/stylish-family-walking-sunny-field.jpg",
];

const AboutPageSection = ({ language = "EN" }) => {
  const [current, setCurrent] = useState(0);

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      tag: "WHO WE ARE",
      title: "Journeying Together Since 1996",
      p1:
        "JT Group is a distinguished financial advisory firm based in Singapore and a proud authorised representative of AIA Singapore Private Limited. Founded by Jeffeury Tan with a team of seven, we have grown into a powerhouse of over 60 dynamic professionals — a testament to resilience, collaboration, and an unwavering commitment to the people we serve.",
      p2:
        "We serve individuals, families, businesses, and high-net-worth clients with bespoke solutions across insurance, wealth management, and legacy planning. But more than the products we offer, it is the relationships we build that define us.",
      list1: "Enduring relationships rooted in trust and care",
      list2: "Strategic guidance across protection & investments",
    },

    zh: {
      tag: "关于我们",
      title: "自 1996 年携手同行",
      p1:
        "JT Group 是一家位于新加坡的卓越金融咨询公司，同时也是 AIA 新加坡的授权代表。公司由 Jeffeury Tan 与七人团队创立，如今已发展为拥有 60 多位专业人士的团队，体现了坚持、合作与对客户的坚定承诺。",
      p2:
        "我们为个人、家庭、企业及高净值客户提供量身定制的保险、财富管理与传承规划方案。相比产品本身，我们更重视与客户建立的长期关系。",
      list1: "建立在信任与关怀基础上的长期关系",
      list2: "全面的保障与投资战略指导",
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-[#f7f7f7] py-12">
      <div className="max-w-[1320px] mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">

       
        <div className="flex flex-col items-center">

          <div className="relative w-full max-w-[600px] h-[320px] overflow-hidden">

            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                className={`absolute w-full h-full object-cover transition-opacity duration-700 ${
                  index === current ? "opacity-100" : "opacity-0"
                }`}
              />
            ))}

          </div>

          <div className="flex gap-3 mt-6">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === current
                    ? "bg-[#C09F7C] scale-110"
                    : "bg-gray-300"
                }`}
              />
            ))}
          </div>

        </div>


        <div>

          <p className="text-[#C09F7C] text-sm font-bold tracking-wide mb-3 uppercase">
            {text[lang].tag}
          </p>

          <h2 className="text-[34px] font-medium text-[#154059] leading-snug mb-5">
            {text[lang].title}
          </h2>

          <p className="text-gray-700 leading-relaxed mb-6">
            {text[lang].p1}
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            {text[lang].p2}
          </p>

          <ul className="space-y-3">

            <li className="flex items-start gap-3">
              <span className="w-2 h-2 mt-2 bg-[#C09F7C] rounded-full"></span>
              <span className="text-gray-700">
                {text[lang].list1}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="w-2 h-2 mt-2 bg-[#C09F7C] rounded-full"></span>
              <span className="text-gray-700">
                {text[lang].list2}
              </span>
            </li>

          </ul>

        </div>

      </div>
    </section>
  );
};

export default AboutPageSection;